customElements.define("border-toggler", class BorderToggler extends HTMLElement{
    constructor(){
        super()

        console.log(this)
        this.btnSquare = this.querySelector('.js-toggle-square')
        this.btnRound = this.querySelector('.js-toggle-round')
        this.squareInputs = document.querySelectorAll('.product-input__input-label--cuadrado')
        this.roundedInputs = document.querySelectorAll('.product-input__input-label--redondo')

        this.btnRound.addEventListener("click", this.toggleRoundSelectors.bind(this))
        this.btnSquare.addEventListener("click", this.toggleSquareSelectors.bind(this))

        this.checkVariantOnLoad()
    }

    checkVariantOnLoad(){
        const currentVariant = document.querySelector('.product-form__input--Panel input[type=radio]:checked') || document.querySelector('.product-form__input--Panneau input[type=radio]:checked')
        const label = currentVariant.parentElement.querySelector(`label[for="${currentVariant.id}"]`)
        if(label.classList.contains("product-input__input-label--redondo")){
            this.toggleRoundSelectors()
        }else{
            this.toggleSquareSelectors()
        }
    }


    toggleRoundSelectors(){
      console.log("hola")
        this.roundedInputs.forEach(input=>input.classList.add('shown'))
        this.squareInputs.forEach(input=>input.classList.add('hidden'))

        this.btnSquare.classList.remove("active")
        this.btnRound.classList.add("active")

        this.checkCurrentVariant("redondo")
    }

    toggleSquareSelectors(){
        this.roundedInputs.forEach(input=>input.classList.remove('shown'))
        this.squareInputs.forEach(input=>input.classList.remove('hidden'))

        this.btnSquare.classList.add("active")
        this.btnRound.classList.remove("active")

        this.checkCurrentVariant("cuadrado")
    }

    checkCurrentVariant(type){
        const currentVariant = document.querySelector('.product-form__input--Panel input[type=radio]:checked') || document.querySelector('.product-form__input--Panneau input[type=radio]:checked')
        console.log(currentVariant.value)
        var newVariantInput
        if(Shopify.locale == "en"){
          newVariantInput = type == "redondo" ? document.querySelector(`.product-form__input--Panel input[value="Round ${currentVariant.value}"]`) : document.querySelector(`.product-form__input--Panel input[value="${currentVariant.value.replace("Round ", "")}"]`)
        }else if(Shopify.locale == "fr"){
          newVariantInput = type == "redondo" ? document.querySelector(`.product-form__input--Panneau input[value="${currentVariant.value} Rond"]`) : document.querySelector(`.product-form__input--Panneau input[value="${currentVariant.value.replace(" Rond", "")}"]`)
        }else{
          newVariantInput = type == "redondo" ? document.querySelector(`.product-form__input--Panel input[value="${currentVariant.value} Redondo"]`) : document.querySelector(`.product-form__input--Panel input[value="${currentVariant.value.replace(" Redondo", "")}"]`)
        }
        newVariantInput.click()
    }
})